import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import { CustomerContext } from "../contexts/CustomerContext";

axios.defaults.withCredentials = true;

const CustomerProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const refreshUser = useCallback(async () => {
    try {
      const res = await axios.get("/customer/check-auth", {
        withCredentials: true,
      });

      if (res.data?.success === true && res.data?.authenticated === true) {
        setIsAuthorized(true);
      } else {
        setIsAuthorized(false);
      }
    } catch (err) {
      setIsAuthorized(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthorized) {
    return <Navigate to="/support" replace />;
  }

  return (
    <CustomerContext.Provider
      value={{
        isAuthorized,
        refreshUser,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};

export default CustomerProtectedRoute;